// extracted by mini-css-extract-plugin
export default {"outlet":"[workspaceId]_outlet__qg559","title":"[workspaceId]_title__pMKry","workspaceInfo":"[workspaceId]_workspaceInfo__7QRqa","details":"[workspaceId]_details__v4tuo"};